/**
 * Rótulo do tipo de chamado (`task_requests.request_type`). Fonte única da tela de
 * chamados — antes havia dois mapas divergentes (lista e triagem) e o detalhe mostrava o
 * valor cru (spec 2026-09-27-chamados-revisao-geral §7). As chaves são o CHECK da coluna
 * (migrations.py), conferidas por teste.
 */
export const ROTULO_DO_TIPO_DE_CHAMADO: Record<string, string> = {
  approval: 'Aprovação',
  incident: 'Incidente',
  service_request: 'Requisição de Serviço',
  change_request: 'Mudança',
  gmud: 'GMUD',
}

export function rotuloDoTipoDeChamado(tipo: string | null | undefined): string {
  if (!tipo) return '—'
  return ROTULO_DO_TIPO_DE_CHAMADO[tipo] ?? tipo
}

export const OPCOES_DO_TIPO_DE_CHAMADO = Object.entries(ROTULO_DO_TIPO_DE_CHAMADO).map(
  ([value, label]) => ({ value, label }),
)
